<template>
  <div class="container videos_block__container">
    <div class="videos_block">
      <div class="videos_block-group">
        <default-title
          v-if="videos_group_title"
          :title="videos_group_title"
          :class="{no_spacing: videos_group_sub_title}"
          title_tag="div"
          class="videos_block-group_title text-center"
          white
        />
        <div
          v-if="videos_group_sub_title"
          class="text-center videos_block-group_sub-title">
          {{videos_group_sub_title}}
        </div>
        <swiper
          class="position-relative"
          add_navigation_buttons
          next_btn_class="image_next_btn"
          prev_btn_class="image_prev_btn"
          :swiper_config="swiper_config"
          :breakpoints="swiper_breakpoints">
          <swiper-slide
            v-for="(video, index) in group_videos"
            :key="`video-carousel-slide_${index}_${uid}`">
            <video-preview-with-play-btn
              class="h-100"
              :image_src="video.image_src"
              :image_lazy_src="video.image_lazy_src"
              :hide_button="!Boolean(video.you_tube_src)"
              @click="openVideo(video)"
            />
          </swiper-slide>
        </swiper>
      </div>
      <div
        v-if="other_videos.length"
        class="videos_block-spliced">
        <div class="videos_block-spliced_row row">
          <div
            v-for="(video, index) in other_videos"
            class="col-sm-4 col-12 videos_block-item"
            :key="`video-slide_${index}_${uid}`">
            <div class="videos_block-gray">
              <div>
                <div
                  ref="gray_title"
                  :style="gray_title_style"
                  class="videos_block-gray_title">
                  {{video.video_title}}
                </div>
                <div
                  v-if="video.video_sub_title"
                  class="text-center mt-10 videos_block-gray_sub-title">
                  {{video.video_sub_title}}
                </div>
              </div>
              <video-preview-with-play-btn
                class="videos_block-gray_content"
                :image_src="video.image_src"
                :image_lazy_src="video.image_lazy_src"
                :hide_button="!Boolean(video.you_tube_src)"
                @click="openVideo(video)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <video-modal ref="video_modal"/>
  </div>
</template>

<script>
import VideoModal from "../modals/VideoModal.vue";
import LazyImage from "../small_parts/LazyImage.vue";
import Swiper from "../modules/Swiper/Swiper.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import uid_mixin from "../../mixins/uid_mixin";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import PlayVideoIcon from "../icons/PlayVideoIcon.vue";
import VideoPreviewWithPlayBtn from "../small_parts/VideoPreviewWithPlayBtn.vue";
import {mapGetters} from "vuex";

export default {
  name: "VideosBlock",
  mixins: [uid_mixin],
  components: {
    VideoPreviewWithPlayBtn,
    PlayVideoIcon,
    DefaultTitle,
    SwiperSlide, Swiper,
    LazyImage,
    VideoModal
  },
  props: {
    /**props**/
    videos_group_title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    videos_group_sub_title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    videos: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        image_src: {
          type: String,
          required: true,
          admin_type: 'image',
        },
        image_lazy_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        you_tube_src: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        video_title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        video_sub_title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
      },
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    group_videos() {
      return this.videos.filter((el, index) => index < 3)
    },
    other_videos() {
      return this.videos.filter((el, index) => index > 2)
    },
    swiper_config() {
      return {
        spaceBetween: 20,
      }
    },
    swiper_breakpoints() {
      return {
        576: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20
        },
      }
    },
    gray_title_style() {
      if (!this.alignment_title_height || this.getIsMobile) return null
      return {
        minHeight: `${this.alignment_title_height}px`
      }
    }
  },
  data() {
    return {
      alignment_title_height: 0
    }
  },
  mounted() {
    this.calculateHeight()
  },
  methods: {
    openVideo({you_tube_src}) {
      if (!you_tube_src) return
      this.$refs.video_modal.openModal(you_tube_src)
    },
    calculateHeight() {
      this.alignment_title_height = Math.max(
        ...(this.$refs.gray_title || []).map(el => el.offsetHeight)
      )
    }
  },
  watch: {
    'getIsMobile'(val) {
      if (val) return
      this.calculateHeight()
    }
  }
}
</script>
